import { styled, alpha } from '@mui/material/styles';
import { Box, Card } from '@mui/material';

export const MainContainer = styled(Box)({
  display: 'flex',
  height: '100%',
  overflow: 'hidden',
  backgroundColor: 'transparent',
  gap: 0,
  margin: '-24px',
});

export const LeftColumn = styled(Box)({
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  padding: '24px',
  overflow: 'auto',
  backgroundColor: 'transparent',
});

export const RightColumn = styled(Box)(({ theme }) => ({
  width: 400,
  flexShrink: 0,
  padding: '24px',
  backgroundColor:
    theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.grey[50],
  borderLeft: `1px solid ${theme.palette.divider}`,
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
}));

export const CartHeaderBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const CartListBox = styled(Box)({
  flex: 1,
  overflow: 'auto',
  minHeight: 0,
});

export const CartEmptyBox = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(4),
}));

export const CartItemCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
  boxShadow: theme.shadows[1],
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
}));

export const SummaryCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.palette.mode === 'dark' ? 'none' : theme.shadows[1],
  backgroundColor: theme.palette.background.paper,
}));

export const SectionPanel = styled(Box)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? alpha(theme.palette.common.white, 0.06)
      : theme.palette.grey[50],
  borderRadius: 16,
  padding: theme.spacing(2.5),
  marginBottom: theme.spacing(3),
}));

export const SectionLabel = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
  marginTop: theme.spacing(0.5),
}));
